export const GENDERS = ['boy', 'girl'];
//# sourceMappingURL=Gender.js.map